/**
 * This directive will replace an image that failed to load, with a solid colour
 */
import {_F} from "../utility/func";
import colourToLegendChip = _F.colourToLegendChip;

export class ErrorColour implements ng.IDirective {

	constructor() {
		this.link = ($scope: ng.IScope, element: ng.IAugmentedJQuery,
					 attrs: ng.IAttributes) => {
			if (element.length) {
				let image = <HTMLImageElement> element[0];
				image.addEventListener('load', (event) => {
					console.log('image load');
					console.log(image);
					console.log(image.complete);
					console.log(event);
				});
			}

			element.bind('error', () => {
				if (!attrs['errorColour']) return;

				let w = Number(attrs['errorWidth']) || 40;
				let h = Number(attrs['errorHeight']) || 30;

				element.attr('src', colourToLegendChip(w, h, attrs['errorColour']));
			});
		}
	}

	link: ($scope: ng.IScope, element: ng.IAugmentedJQuery,
		   attrs: ng.IAttributes) => void = null;

	static factory(): ng.IDirectiveFactory {
		const directive = () => new ErrorColour();
		directive.$inject = [];
		return directive;
	}
}